import React from "react";

const BS5_Editor = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Editor Component</h2>
      <p>This is the BS5_Editor component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Editor;
